module.exports = function getResource(label, vars = []) {
    let resources = {
        installments: `Crédit offert par ${vars[0]}`,
        testCardDiscount: `Ou une réduction de ${vars[0]} $ sur votre commande Sephora lors de l’ouverture et l’utilisation de votre carte de crédit Sephora dès aujourd'hui¹.`,
        testCardDiscountBasketText: `or ${vars[0]} off when you open and use your Sephora Credit Card on this purchase today.¹`,
        testSeeDetails: 'Voir les détails',
        learnMore: 'En savoir plus',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.'
    };

    return resources[label];
};
